import * as Types from '@typings/graphql-models';

const isSubscriptionPrice = (price: Pick<Types.Price, 'usageType'>): boolean => (price.usageType === Types.StripePriceUsageType.Recurring);
export default isSubscriptionPrice;
